import React from "react";
import Button from "../../components/Button";

export default function SuccessStorySection() {
  return (
    <section className=" responsive-padding py-12 bg-secondary-lightActive">
      <div className="flex flex-col laptopSm:flex-row gap-8 lg:gap-24">
        <div className=" lg:w-[30%]">
          <div className="h-[376px] lg:h-[416px] w-full mb-4">
            <img
              src="/image/grad-pic.jpg"
              alt=""
              className="rounded-successPicStory-custom w-full h-full object-cover object-center"
            />
          </div>
          <h1 className="font-montserrat font-semibold text-lg md:text-xl lg:text-2xl text-justify lg:text-start tracking-[0.04em] leading-none">
            From JMIF Classrooms to Silicon Valley: The Journey of John David
            Cruz
          </h1>
        </div>
        <div className="lg:w-[70%]">
          <h6 className="font-montserrat font-semibold text-base md:text-xl lg:text-3xl mb-5">
            Success Story of John
          </h6>
          <div className="grid gap-4 font-notoSans text-xs md:text-sm leading-6 tracking-[0.06em] text-grey-normal text-justify mb-5">
            <p>
              John David Cruz, a proud graduate of JMIF’s Class of 2010, has
              taken the skills and values he learned at our school to new
              heights in the world of technology. After graduating from JMIF,
              John pursued a degree in Computer Science at MetroTech University,
              where he graduated with honors.
            </p>{" "}
            <p>
              John’s passion for innovation led him to Silicon Valley, where he
              began his career as a software engineer at a leading tech firm.
              His dedication, creativity, and problem-solving skills quickly
              caught the attention of his peers, and within a few years, he was
              promoted to lead a team of developers working on cutting-edge
              artificial intelligence projects.
            </p>
            <p>
              John’s passion for innovation led him to Silicon Valley, where he
              began his career as a software engineer at a leading tech firm.
              His dedication, creativity, and problem-solving skills quickly
              caught the attention of his peers, and within a few years, he was
              promoted to lead a team of developers working on cutting-edge
              artificial intelligence projects.
            </p>
          </div>
          <div className="flex justify-center laptopSm:justify-start items-center ">
            <Button text={"Read More"} type={"outline"} navigateTo={""} />
          </div>
        </div>
      </div>
    </section>
  );
}
